import React from "react";
import Media from "../media";
import Footer from "../global/footer";
import Header from "../global/header";

const V00Media = ({header, footer}) => {
  const {menuv0} = footer;

  return (
    <>
     <Header header={header} />
      <Media isBg="yes" />
      <Footer  isBg="" menu={menuv0} />
    </>
  );
}

export default V00Media;
